<template>
  <div class="banner">
    <div class="banner-img">
      <img src="../../assets/img/bgtop.jpg" />
    </div>
    <div class="banner-title">
      <p>{{title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "../../assets/img/bgtop.jpg"
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 150px;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  img {
    position: absolute;
	width: 100%;
    height: 100%;
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 150px;
    text-align: center;
    width: 100%;
  }
}
</style>